import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Permission from '@/view/record/permission/Permission'

export default {
  path: '/permission',
  name: 'Permission',
  components: {
    default: Permission,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Permissão' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/PermissionRoute.js